import { i18n } from '@/commons/utils';
import { getParameters, validator } from '../customer-utils';


const rules = {
  rules: {
    title: {
      extendedalphanumeric: true
    },
    mobile: {
      mobile: true
    },
    landline: {
      mobile: true
    },
    name: {
      extendedalphanumeric: true
    },
    surname: {
      extendedalphanumeric: true
    }
  },

  messages: {
    title: {
      required: i18n('shippingAddress.error.streetNameRequired')
    },
    name: {
      required: i18n('shippingAddress.error.nameRequired')
    },
    streetName: {
      required: i18n('shippingAddress.error.streetNameRequired')
    },
    mobile: {
      required: i18n('shippingAddress.error.mobileRequired'),
      pattern: i18n('validationMsg.mobile')
    }
  }
};

export const init = id => {
  const form = cube.$id(id);
  const country = cube.$id('countryCodeGeoId');
  const checkbox = cube.$id('add-in-address-book-checkbox');

  validator(
    form,
    ':hidden:not(.selectpicker), .bs-searchbox input',
    rules
  );

  cube.form.address.init(country.value, 'BILLING');

  country.on('change', updateCountryCodeGeoId);
  checkbox.on('change', displayComplementaryField);
};


const updateCountryCodeGeoId = event => {
  cube.form.address.init(event.target.value, 'BILLING');
};


/**
 * Display or hide complementary field for home address (name, surname, phone number, ...).
 *
 * @param {Event} event
 */
const displayComplementaryField = event => {
  const fields = cube.$id('complementary-fields');

  if (event.target.checked)
    fields.classList.remove('hide');
  else
    fields.classList.add('hide');
};


/**
 * Make an XHR to reload the home address form.
 *
 * @param {HTMLFormElement} form The home address form.
 * @param {Function} callback The action to execute after the XHR.
 */
export const reloadHomeAddressForm = (form, callback) => {
  const cityGeoId = cube.$id('cityGeoId');

  if (cityGeoId && cityGeoId.value) {
    cityGeoId.disabled = false;
    $(cityGeoId).selectpicker('refresh');
  }

  if ($(form).valid()) {
    const param = getParameters(form);

    cube.cartridge('address')
      .after(data => {
        if (!(data instanceof Object)) {
          cube.alert.success(i18n('profile.changesSaved'));
          init(form.id);

          if (callback)
            callback();
        }
      })
      .reload(param);
  }
};


// WEBPACK FOOTER //
// ./src/customer/account/account-profile-home-address.js